export const LARGE_DESK_SCREEN = 'screen and (min-width: 1200px)';
export const MEDIUM_DESK_SCREEN = 'screen and (min-width: 1024px) and (max-width: 1199px)';
export const TABLET_SCREEN = 'screen and (min-width: 768px) and (max-width: 1023px)';
export const MOBILE_SCREEN = 'screen and (max-width: 767px)';

export const mediaSmallDesk = `@media ${MEDIUM_DESK_SCREEN}`;
export const mediaTablet = `@media ${TABLET_SCREEN}`;
export const mediaMobile = `@media ${MOBILE_SCREEN}`;
